<h2>{{ "clients.populations" | transloco }}</h2>

<header>
  <div id="filters">
    <div class="ui left icon input">
      <i class="search icon"></i>
      <input
        [attr.data-test-ref]="'search-population'"
        type="text"
        [(ngModel)]="populationSearch"
        placeholder="{{ 'clients.search-populations' | transloco }}"
      />
    </div>
  </div>

  @if (userInfo.isClientAdmin) {
  <div [attr.data-test-ref]="'create-new'">
    <div class="ui primary button" (click)="openPopulationModal()">
      {{ "clients.new-population" | transloco }}
    </div>
  </div>
  }
</header>

@if ( !populations || populations?.length == 0 || (populations | keyWord:
['name']:populationSearch)?.length == 0 ) {
<div id="no-results">
  {{ "clients.no-populations-found" | transloco }}
</div>
} @if (populations?.length > 0) {
<table id="list" width="100%" cellspacing="0">
  @for ( population of populations | keyWord: ['name']:populationSearch ; track
  population) { @if (population.status !== 99) {
  <tr>
    <td class="population-name">
      <strong>{{ population?.name }}</strong>
    </td>
    <td class="population-taxpayers" *transloco="let t">
      {{ population?.totalAssignees }} {{ taxpayerAlias }}
      {{ population?.totalAssignees === 1 ? "" : t("clients.s") }}
    </td>
    @if ( showCountries &&
    !configState.featureFlags.onlyAllowSingleCountryPerClient ) {
    <td>
      {{ getPopulationCountryCode(population?.countryId) }}
    </td>
    }
    <td
      [routerLink]="[population?.id, uiConfig.config.taxpayerAliasPath]"
      [queryParams]="{ taxYear: taxYr }"
      class="view-population"
      align="right"
    >
      <strong>{{ "clients.view" | transloco }}</strong>
    </td>
    <td
      [routerLink]="[population?.id, 'rules']"
      [queryParams]="{ category: 1, taxYear: taxYr }"
      class="edit-population"
    >
      <strong *transloco="let t">{{
        canEditClientRules() &&
        (userAccessCountriesIds.includes(population?.countryId) ||
          !population?.countryId)
          ? t("clients.edit")
          : t("clients.client-rules")
      }}</strong>
    </td>
  </tr>
  } }
</table>

} @if (userInfo.isClientAdmin) {
<div>
  <div #newPopulationModal id="new-population-modal" class="ui tiny modal">
    <div class="icon modal-close close"></div>
    <h1>{{ "clients.create-new-population" | transloco }}</h1>
    <p>{{ "clients.for-client-name" | transloco: { name: client?.name } }}</p>
    <form (ngSubmit)="saveNewPopulation()">
      <div class="content">
        <label>{{ "clients.population-name" | transloco }}</label>
        <input
          [attr.data-test-ref]="'new-population-name-input'"
          type="text"
          name="name"
          [(ngModel)]="newPopulationName"
        />
      </div>
      @if (!configState.featureFlags.onlyAllowSingleCountryPerClient) {
      <div [hidden]="!showCountries" class="content">
        <label>Country</label>
        <div class="ui search selection dropdown" #countryDropDown>
          <i class="chevron down icon"></i>
          <div class="text"></div>
          <div class="menu"></div>
        </div>
        <input
          type="hidden"
          [(ngModel)]="newPopulationCountryId"
          name="countryId"
        />
      </div>
      }
      <div class="actions">
        <span
          [attr.data-test-ref]="'create-population-name-cancel'"
          class="go-back cancel"
          >{{ "clients.cancel" | transloco }}</span
        >
        <button
          [attr.data-test-ref]="'create-population-name-create'"
          class="ui primary background button"
          [ngClass]="{ disabled: !newPopulationName }"
        >
          {{ "clients.create" | transloco }}
        </button>
      </div>
    </form>
  </div>
  <div #newPopulationSuccessModal id="success-modal" class="ui tiny modal">
    <div class="icon modal-close close"></div>
    <div class="content">
      <div class="icon green-success"></div>
      <h3>
        {{ "clients.new-population" | transloco }}
        <strong>{{ newPopulationName }}</strong>
        {{ "clients.created-successfully" | transloco }}
      </h3>
    </div>
    <div class="actions">
      <div
        [attr.data-test-ref]="'population-created-successfully-okay'"
        class="ui primary background button approve"
      >
        {{ "clients.ok" | transloco }}
      </div>
    </div>
  </div>
</div>
}
